import { Svg } from '../svg';

type SvgSize = number | string;
export interface IconProps {
  textColor?: string | undefined;
  size?: SvgSize;
  isSmall?: boolean | undefined;
}

export const IconWrapper = ({
  size = 32,
  children,
  viewBox = '0 0 32 32',
}: React.PropsWithChildren<{
  size?: SvgSize | undefined;
  viewBox?: string;
}>) => {
  return (
    <Svg viewBox={viewBox} height={size} width={size}>
      {children}
    </Svg>
  );
};

export const createSlideIcon =
  (
    Small: React.ComponentType<IconProps>,
    Normal: React.ComponentType<IconProps>,
  ) =>
  ({ size, isSmall, textColor }: IconProps) => {
    const iconViewBox = isSmall ? '0 0 24 24' : '0 0 32 32';
    const Element = isSmall ? Small : Normal;
    const iconSize = size || (isSmall ? 24 : 32);

    return (
      <IconWrapper size={iconSize} viewBox={iconViewBox}>
        <Element textColor={textColor} />
      </IconWrapper>
    );
  };
